var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1685_30409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6947 8.26562L14.4567 12.3536L9.09766 8.26562L9.10466 8.27163V13.9966L14.3957 18.1736L19.6957 14.1576V8.26562H19.6947Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0713 7.27532L19.6953 8.27032V14.1623L24.0243 10.8393V8.83632C24.0243 8.83632 23.4983 5.97632 21.0713 7.27632V7.27532Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6953 14.1678V21.8108H23.0133C23.0133 21.8108 23.9573 21.7137 24.0253 20.6377V10.8438L19.6953 14.1678Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10444 21.8141V14.0041L9.09744 13.9981L9.10444 21.8141ZM9.09644 8.27213L7.72744 7.28413C5.30044 5.98413 4.77344 8.84413 4.77344 8.84413V10.8461L9.09644 13.9971V8.27213ZM9.09844 8.27413L9.09744 13.9981L9.10444 14.0041V8.27913L9.09744 8.27313L9.09844 8.27413Z",
    fill: "#C5221F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 10.8438V20.6377C4.77244 20.9224 4.87429 21.1978 5.06024 21.4134C5.24618 21.6289 5.50372 21.77 5.78544 21.8108H9.10344L9.09644 13.9948L4.77344 10.8448V10.8438Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1685_30409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.398438 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.65061e9801cbe3b7123ee2fff29620ed.svg";
export { ForwardRef as ReactComponent };